import jBox from 'jbox';
import 'jbox/dist/jBox.all.css';

jQuery(document).ready(function () {

    if(jQuery('.single-athlete').length > 0) {

        console.log(jQuery('#tooltip_left'))


        new jBox('Tooltip', {
            attach: '.tooltip',
            closeOnMouseleave: true,
         });

        jQuery('#tooltip_left').jBox('Tooltip', {
            pointer: 'left:15', // The pointer is moved to the right with a 15 pixel offset
            closeOnMouseleave: true,
        });

    }

});
